/**
 * 货币代码枚举
 */
export const CurrencyCode = {
  CNY: { label: '人民币', value: 'CNY' },
  USD: { label: '美元', value: 'USD' },
  EUR: { label: '欧元', value: 'EUR' },
  JPY: { label: '日元', value: 'JPY' },
  GBP: { label: '英镑', value: 'GBP' },
  HKD: { label: '港元', value: 'HKD' },
  AUD: { label: '澳元', value: 'AUD' },
  CAD: { label: '加元', value: 'CAD' },
  CHF: { label: '瑞士法郎', value: 'CHF' },
  SGD: { label: '新加坡元', value: 'SGD' }
}

/**
 * 发票方向枚举
 */
export const InvoiceDirection = {
  INPUT: { label: '进项', value: 0 },
  OUTPUT: { label: '销项', value: 1 }
}

/**
 * 发票状态枚举
 */
export const InvoiceStatus = {
  WAIT_VERIFY: { label: '待验证', value: 0, tagType: 'warning' },
  WAIT_VERIFY_VERIFY: { label: '待核销', value: 1, tagType: 'primary' },
  PARTIAL_WRITTEN_OFF: { label: '部分核销', value: 2, tagType: 'primary' },
  VERIFIED: { label: '已核销', value: 3, tagType: 'success' },
  CANCELED: { label: '已作废', value: 9, tagType: 'info' }
}

/**
 * 发票类型枚举
 */
export const InvoiceType = {
  SPECIAL_USE: { label: '增值税专用发票', value: 0 },
  ORDINARY: { label: '增值税普通发票', value: 1 }
}

/**
 * 发票验证状态枚举
 */
export const InvoiceVerifyStatus = {
  PENDING: { label: '待验证', value: 0 },
  COMPLETED: { label: '验证通过', value: 1 },
  VERIFY_NOT_PASS: { label: '验证未通过', value: 2 }
}

/**
 * 核销状态枚举
 */
export const WrittenOffStatus = {
  PENDING: { label: '待核销', value: 0 },
  PARTIAL_WRITTEN_OFF: { label: '部分核销', value: 1 },
  COMPLETED: { label: '已核销', value: 2 }
}
